import React from 'react';
import { api } from '../lib/api';
import type { SiteSettings } from '../types';

export default function SiteMeta() {
  React.useEffect(() => {
    let cancelled = false;
    api
      .get<SiteSettings>('/settings')
      .then((s) => {
        if (cancelled) return;
        if (s.company_name) document.title = s.company_name;
        if (s.favicon_url) {
          let link = document.querySelector<HTMLLinkElement>('link[rel="icon"]');
          if (!link) {
            link = document.createElement('link');
            link.rel = 'icon';
            document.head.appendChild(link);
          }
          link.href = s.favicon_url;
        }
      })
      .catch(() => {});
    return () => { cancelled = true; };
  }, []);

  return null;
}
